export default "__VITE_ASSET__DRzDNb$E__"